import { render } from "./InsIcon.vue?vue&type=template&id=75de4180"
import script from "./InsIcon.vue?vue&type=script&lang=js"
export * from "./InsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__